import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_CUISINES = "GET_CUISINES";

export function getCuisines(token) {
  const request = axios.get(
    "/cuisines/",
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_CUISINES,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}



// WEBPACK FOOTER //
// ./src/store/actions/cuisine.js